module.exports = __webpack_public_path__ + "img/info-circle.45a156d4.svg";